import { type FundDataWithType } from "@hsl/fund-explorer/metaSchemas";

import CardColCell from "../../CardColCell";
import Tag from "../../Tag";

interface Props {
    fund: FundDataWithType;
    stackedPMCTags?: boolean;
}

const TagsView = ({ fund, stackedPMCTags }: Props) => {
    let tags = [];

    switch (fund.type) {
        case "pmc":
            if (stackedPMCTags) {
                const { subGrouping, capabilityStyle } = fund.data.data;
                return (
                    <div className="-mb-4 flex-1 text-left">
                        <p className="line-clamp-1 text-sm">
                            {capabilityStyle}
                        </p>
                        <p className="line-clamp-1 text-sm">{subGrouping}</p>
                    </div>
                );
            } else {
                const { subGrouping, capabilityStyle } = fund.data.data;
                return (
                    <div className="mb-4 flex justify-end gap-x-4 sm:mb-0">
                        <span className="flex min-w-[150px] flex-wrap gap-x-2 text-left">
                            <span className="hidden md:inline-block">
                                {capabilityStyle}
                            </span>
                        </span>
                        <CardColCell>{subGrouping}</CardColCell>
                    </div>
                );
            }
        case "collective":
            tags = [fund.data.data.assetClass, fund.data.data.style];
            break;
        case "etf":
            tags = [fund.data.data.assetClass, fund.data.data.strategy];
            break;
    }

    return (
        <div className="flex flex-row-reverse gap-x-2">
            {tags.map((tag, i) => (
                <Tag
                    key={`${tag}${i}`}
                    type={i % 2 === 0 ? "dark" : "light"}
                    size="small"
                    text={tag}
                />
            ))}
        </div>
    );
};

export default TagsView;
